module.exports = {"title":"Share Your Event","content":"Buy your tickets for"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Share/locales/en.json
// module id = 1293
// module chunks = 0